module.exports = "/packs/likes-logo-white-d0d43e4e738a09c79da331e2711a1d3c.png";